import React from 'react'
import PropTypes from 'prop-types'

import { TableRow, TableHead, TableSortLabel, Checkbox } from '@material-ui/core'

import EnhancedTableCell from './TableCell'
import { useTranslation } from 'react-i18next'
// const { t } = useTranslation();
const headCells = [
  { id: 'img', numeric: false, disablePadding: true, label: 'template' },
  { id: 'name', numeric: false, disablePadding: true, label: 'customer' },
  { id: 'id', numeric: true, disablePadding: false, label: 'templateID' },
  { id: 'tempName', numeric: true, disablePadding: false, label: 'templateName' },
  { id: 'category', numeric: false, disablePadding: false, label: 'category' },
  { id: 'tags', numeric: true, disablePadding: false, label: 'tags' },
  { id: 'options', numeric: true, disablePadding: false, label: 'options' }
]

function EnhancedTableHead({ classes, onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort }) {
  const { t } = useTranslation()
  const createSortHandler = property => event => {
    onRequestSort(event, property)
  }

  return (
    <TableHead>
      <TableRow>
        <EnhancedTableCell padding="checkbox">
          <Checkbox
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{ 'aria-label': 'select all desserts' }}
          />
        </EnhancedTableCell>
        {headCells.map(headCell => (
          <EnhancedTableCell
            key={headCell.id}
            align={'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {t(headCell.label)}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
              ) : null}
            </TableSortLabel>
          </EnhancedTableCell>
        ))}
      </TableRow>
    </TableHead>
  )
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired
}

export default EnhancedTableHead
